export default __webpack_public_path__ + "static/media/youtube.3de2a55b.svg";